var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 10.5625C12.5 9.18178 11.3807 8.06253 10 8.06253C8.61925 8.06253 7.5 9.18178 7.5 10.5625C7.5 11.9433 8.61925 13.0625 10 13.0625C11.3807 13.0625 12.5 11.9433 12.5 10.5625Z",
    stroke: "#6B7280",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 4.72919C13.4848 4.72919 16.47 8.07354 17.7143 9.69769C18.1095 10.2136 18.1095 10.9114 17.7143 11.4274C16.47 13.0515 13.4848 16.3959 10 16.3959C6.5152 16.3959 3.53 13.0515 2.2857 11.4274C1.89048 10.9114 1.89049 10.2136 2.2857 9.69769C3.53 8.07354 6.5152 4.72919 10 4.72919Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPasswordIcon);
export default __webpack_public_path__ + "static/media/view-password-icon.a1bfab972397ad2aaf5e0c90414f5e9f.svg";
export { ForwardRef as ReactComponent };